export default __webpack_public_path__ + "static/DonCurry-d37a74520ae9f94c928a9265ccb0b98d.jpg";